export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			items: [				
				{
					title: 'Inicio',
					root : true,
					alignment: 'left',
					toggle: 'click',
					submenu: [
						{
							title: 'Planta I',
							page: '/production/plant/1'
						},
						{
							title: 'Planta II',
							page: '/production/plant/2'
						}				
					]
				},
				{
					title: 'Producción Planta',
					root : true,
					alignment: 'left',
					toggle: 'click',
					submenu: [
						{
							title: 'Tiempo real',
							submenu: [
								{
									title: 'Máquinas por turno y producto',
									page: '/production/realtime-machines'
								},
								{
									title: 'Cosecha nueces (Reformular)',
									page: '/production/realtime-harvest',
									groups: [4, 5]
								},
								{
									title: 'Monitoreo',
									page: '/production/realtime-silos-dashboard',
									groups: [4, 5]
								},
								{
									title: 'Detenciones',
									page: '/production/realtime-weight-meter',
									groups: [4, 5],
								}
							]
						},
						{
							title: 'Historia',
							submenu: [
								{
									title: 'Por turno y Producto',
									page: '/production/history-drying'
								},
								{
									title: 'Por máquina y producto',
									page: '/production/history-almonds'
								},
								{
									title: 'Temperaturas',
									page: '/production/realtime-silos-temperature',
									groups: [4, 5],
								},
							]
						},
					]
				},
				{
					title: 'Reportes planta',
					root: true,
					aligment: 'left',
					toggle: 'click',
					submenu: [
						{
							title: 'Por turno, producto, máquina',
							page: '/production/report-walnuts'
						},
						{
							title: 'Mensuales',
							page: '/production/reports'
						},
					]
				},
				{
					title: 'Configuración Planta',
					root : true,
					alignment: 'left',
					toggle: 'click',
					submenu: [
						{
							title: 'Plantas',
							page: '/plant-configuration/plants'
						},
						{
							title: 'Máquinas',
							page: '/plant-configuration/machines'
						},
						{
							title: 'Turnos',
							page: '/plant-configuration/shifts'
						},
						{
						 	title: 'Productos',
						 	page: '/plant-configuration/product'
						},
						{
							title: 'Operador',
							page: '/plant-configuration/operators'
						},
						{
							title: 'Órdenes de trabajo',
							page: '/plant-configuration/work-orders'
						},
					]
				},				
				{
					title: 'Reportes',
					root : true,
					alignment: 'left',
					toggle: 'click',
					groups: [4, 5],
					submenu: [
						{
							title: 'Configuración',
							page: '/alarms/alarmscfg'
						}
					]
				},
				{
					title: 'Alarmas',
					root : true,
					alignment: 'left',
					toggle: 'click',
					groups: [4, 5],
					submenu: [
						{
							title: 'Inicio',
							page: '/alarms/alarmsdashboard'
						},
						{
							title: 'Configuración',
							page: '/alarms/alarmscfg'
						}
					]
				},
				{
					title: 'Configuración ControlIR4',
					root : true,
					alignment: 'left',
					toggle: 'click',
					groups: [4, 5],
					submenu: [
						{
							title: 'Módulos',
							page: '/controlir4-config/modules',
							
						},
					]
				},
				{
					title: 'Administración',
					root : true,
					alignment: 'left',
					toggle: 'click',
					submenu: [
						{
							title: 'Usuarios',
							page: '/user-management/users'
						},
						{
							title: 'Perfiles',
							page: '/user-management/roles'
						},
						{
							title: 'Empresas',
							page: '/user-management/companies',
							groups: [4, 5]
						}
					]
				}
			]
		},
	};

	public get configs(): any {
		return this.defaults;
	}
}
